import $ from 'jquery';
// import { switchEditorModeClickListener } from '~loader/loader-utils';
import { deleteUserFormat } from '../loader-api';
import { getState } from '~src/state';
import Swal from 'sweetalert2';
import { renderLoader } from '~loader/renderLoader';
import { onErrorShowMessage, genericSuccess } from '~src/errors';
import { templateCollapseBox } from '~loader/loader-template';
import { requestNewFormat } from '~src/userRequest';
import { fetchCountEditorProjectsByFormat } from '../../~graphql/controllers';

export const initLoaderClickListeners = () => {
  $('body').on('click', '#requestFormat', requestNewFormat);

  /**
   * Contextual Menu
   */

  const closeLoaderContextMenu = ($trigger) => {
    if (!$trigger || !$trigger.length) return;
    $trigger.removeClass('is-open');
    let $menu = $trigger.data('ctxMenu');
    if (!$menu || !$menu.length) {
      $menu = $trigger.find('.sidebar-context-menu');
    }
    $menu.removeClass('is-open');
    $menu.css({ top: '', left: '', transform: '', position: '' });
    // Restore parent if portaled
    try {
      const $origParent = $menu.data('origParent');
      if ($origParent && $origParent.length) {
        $origParent.append($menu);
      }
    } catch (e) {
      console.error('Failed restoring menu parent after close', e);
    }
    // no-op: overlay removed
  };

  const closeAllLoaderMenus = (exclude) => {
    // Close any triggers marked as open
    $('.sidebar-context-menu-trigger.is-open').each((_, el) => {
      if (exclude && exclude.is(el)) return;
      closeLoaderContextMenu($(el));
    });
    // Additionally, force close any orphaned/portaled menus
    $('.sidebar-context-menu.is-open').each((_, el) => {
      const $menu = $(el);
      $menu.removeClass('is-open');
      $menu.css({ top: '', left: '', transform: '', position: '' });
      try {
        const $origParent = $menu.data('origParent');
        if ($origParent && $origParent.length) {
          $origParent.append($menu);
        }
      } catch (e) {
        console.error('Failed restoring menu parent while closing all', e);
      }
    });
  };

  const openLoaderContextMenu = ($trigger) => {
    if (!$trigger || !$trigger.length) return;
    closeAllLoaderMenus($trigger);
    $trigger.addClass('is-open');
    const $menu = $trigger.find('.sidebar-context-menu');
    $menu.addClass('is-open');
    try {
      if (!$menu.data('origParent')) {
        $menu.data('origParent', $menu.parent());
      }
      if ($menu.parent()[0] !== document.body) {
        $('body').append($menu);
      }
      $trigger.data('ctxMenu', $menu);
    } catch (e) {
      console.error('Failed portal sidebar menu to body', e);
    }
    // overlay removed
    try {
      const trigRect = $trigger[0].getBoundingClientRect();
      const menuEl = $menu[0];
      const menuRect = menuEl.getBoundingClientRect();
      const gap = 8;
      const alignLeft = $trigger.is('[data-menu-align="left"]');
      // Align menu top with trigger top for consistency
      const top = Math.round(trigRect.top);
      let left;
      if (alignLeft) {
        left = Math.round(trigRect.left - menuRect.width - gap);
        $menu.css('transform-origin', 'right top');
      } else {
        left = Math.round(trigRect.right + gap);
        $menu.css('transform-origin', 'left top');
      }
      $menu.css({
        position: 'fixed',
        top: `${top}px`,
        left: `${left}px`,
        transform: 'translateY(0) scale(1)',
        'z-index': 100001,
      });
    } catch (e) {
      console.error('Failed to compute context menu position', e);
    }
  };

  $('body').on('click', '.sidebar-context-menu-trigger', function (event) {
    event.stopPropagation();
    const $trigger = $(this);
    if ($trigger.hasClass('is-open')) closeLoaderContextMenu($trigger);
    else openLoaderContextMenu($trigger);
  });

  $('body').on('click', '.sidebar-context-menu .item', function () {
    // When menu is portaled to body, .closest(trigger) may fail. Close all.
    closeAllLoaderMenus();
  });

  $('body').on('click', (event) => {
    const $target = $(event.target);
    if ($target.closest('.sidebar-context-menu-trigger').length) return;
    closeAllLoaderMenus();
  });

  // ESC close
  $(document)
    .off('keydown.loaderContext')
    .on('keydown.loaderContext', (e) => {
      if (e.key === 'Escape') {
        closeAllLoaderMenus();
      }
    });

  $('body').on('click', '[data-container-collapse]', (event) => {
    event.stopPropagation();
    const containerName = $(event.currentTarget).data('container-collapse');
    if ($(`#container-${containerName}`).hasClass('collapseBoxContainers')) {
      $(`#container-${containerName}`)
        .removeClass('collapseBoxContainers')
        .removeClass(`bg-color-${containerName}`);
      $(`#editor-${containerName}`).show();
      $(`#${containerName}-container-title`).show();
      $(`#editor-${containerName}-collapsed`).empty();
      $('#requestFormat').show();
    } else {
      templateCollapseBox();
    }
  });

  /**
   * Delete Format
   */
  $('body').on('click', '.menu-delete-format', async (e) => {
    const formatId = $(e.currentTarget).attr('data-id');
    const projectsCount = await fetchCountEditorProjectsByFormat(formatId);

    if (projectsCount.count > 0) {
      Swal.fire({
        text: `Non è possibile eliminare questo formato perché hai ${
          projectsCount.count == 1
            ? 'un progetto che usa questo formato.'
            : `${projectsCount.count} progetti che usano questo formato.`
        }`,
        icon: 'warning',
        confirmButtonColor: '#278e8e',
      });
    } else {
      Swal.fire({
        text: 'Sto eliminando il formato...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });
      const deletedFormat = await deleteUserFormat(formatId);
      const selectedProjectType = getState('selected.tipo');

      if (deletedFormat.status == 204) {
        const newFormats = window.editorLoader.formats[
          selectedProjectType.objectId
        ].formats.items.filter((format) => format.objectId !== formatId);
        window.editorLoader.formats[
          selectedProjectType.objectId
        ].formats.items = newFormats;

        await renderLoader();
        await genericSuccess(
          'Eliminato',
          'Il formato è stato correttamente eliminato.'
        );
      } else {
        onErrorShowMessage('Non ho potuto eliminare il formato!');
      }
    }
  });
};
